import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TransformationProduct } from '../models/product.model';

@Injectable({
  providedIn: 'root'
})
export class OrderReservationService {

  private url = environment.api + "api/erp/order-reservations";
  constructor(
    private http: HttpClient,
  ) { }

  saveSaleOrder(data: any){
    return this.http.post(this.url, data);
  }

  getQuantityTransitProductAndWarehouse(warehouse: any, productId: any) {
    return this.http.get(this.url + `/quantities-transit/${warehouse}/${productId}`);
  }

  getReservations(startDate: number, endDate: number) {
    const params = `?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(`${this.url}/by-date${params}`);
  }

  getGroupedReservations(startDate: number, endDate: number, warehouse: number){
    return this.http.get(`${this.url}/warehouses/${warehouse}/${startDate}/${endDate}`);
  }

  getReservationDetail(orderReservationId: number) {
    return this.http.get(`${this.url}/detail/${orderReservationId}`);
  }

  getAllWarehouseExistence(productId){
    return this.http.get(`${environment.api}api/erp/inventory/product/warehouses-existence/${productId}`);
  }

  getQuantityTransitProduct(productId: any) {
    return this.http.get(this.url + `/quantities-transit/${productId}`);
  }

  getQuantityReservationProduct(productId: any) {
    return this.http.get(this.url + `/quantities-reserved/${productId}`);
  }

  cancelReservation(orderReservationId:number){
    return this.http.put(this.url + `/${orderReservationId}/confirmations/false`,null);
  }

  confirmReservation(orderReservationId:number){
    return this.http.put(this.url + `/${orderReservationId}/confirmations/true`,null);
  }

  transferOrderReservation(orderReservationId: number, request: any) {
    return this.http.post(`${this.url}/transfer/${orderReservationId}`, request);
  }

  transferOrderReservationGrouped(request: any) {
    return this.http.post(`${this.url}/transfer/grouped`, request);
  }

  transferProductValidation(toWarehouse: any, issuedDate: any) {
    return this.http.get(this.url + `/transfer/validate/${toWarehouse}/${issuedDate}`);
  }

}
